// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"Icon_iconWrapper__xb_UL","expand":"Icon_expand__rbYvw","closing":"Icon_closing__MJAj_"};